import { call, put } from 'redux-saga/effects'
import { saga_act } from 'src/types'

import { shoot } from '../actions'
import { saga_do_request } from './base.saga'
import { group_outcome_t } from 'src/types/http/group.types';
import { http_group } from 'src/http/group.http';

/**
 * Get group
 */
export function* saga_group(action: saga_act): unknown {
	const group: group_outcome_t = yield call(
		saga_do_request,
		http_group,
		action
	);
	if (group) {
		yield put(shoot.reduce_group(group));
	}
}